import React from "react";

import { Route, Switch } from "2g-router";
import PageContent from "2g-page-content";

import { PATHS, PAGE_TITLES } from "b2b/constants";
import ZakazniciGrid from "b2b/components/zakaznici-grid/ZakazniciGrid";
import KonfiguracniParametry from "./KonfiguracniParametry";
import ZakaznikDetail from "./ZakaznikDetail";
import Zdroje from "./Zdroje";
import ZdrojDetail from "./ZdrojDetail";
import ProduktDetail from "./ProduktDetail";
import DoplnkovaSluzbaDetail from "./DoplnkovaSluzbaDetail";

export function Administrace() {
  return (
    <div>
      <Switch>
        <Route path={PATHS.ADMINISTRACE.KONFIGURACNI_PARAMETRY}>
          <KonfiguracniParametry />
        </Route>
        <Route path={PATHS.ADMINISTRACE.ZAKAZNIK}>
          <ZakaznikDetail />
        </Route>
        <Route
          path={PATHS.ADMINISTRACE.ZAKAZNICI}
          exact
          title={PAGE_TITLES.ADMINISTRACE_ZAKAZNICI}
        >
          <PageContent>
            <ZakazniciGrid />
          </PageContent>
        </Route>
        <Route
          path={PATHS.ADMINISTRACE.ZDROJE}
          exact
          title={PAGE_TITLES.ADMINISTRACE_ZDROJE}
        >
          <PageContent>
            <Zdroje />
          </PageContent>
        </Route>
        <Route path={PATHS.ADMINISTRACE.ZDROJ}>
          <ZdrojDetail />
        </Route>
        <Route path={PATHS.ADMINISTRACE.PRODUKT}>
          <ProduktDetail />
        </Route>
        <Route path={PATHS.ADMINISTRACE.DOPLNKOVA_SLUZBA}>
          <DoplnkovaSluzbaDetail />
        </Route>
      </Switch>
    </div>
  );
}

Administrace.propTypes = {};

export default React.memo(Administrace);
